import React from 'react';
import { bool, func, number, object, oneOf, string } from 'prop-types';
import defaultClasses from './toast.css';
import { mergeClasses } from '../../classify';
import Icon from '../Icon';
import { X as CloseIcon } from 'react-feather';
var Toast = props => {
  var {
    actionText,
    dismissable,
    icon,
    message,
    onAction,
    handleAction,
    onDismiss,
    handleDismiss,
    type
  } = props;
  var classes = mergeClasses(defaultClasses, {});
  var iconElement = icon ? /*#__PURE__*/React.createElement(React.Fragment, null, icon) : null;
  var controls = onDismiss || dismissable ? /*#__PURE__*/React.createElement("button", {
    className: classes.dismissButton,
    onClick: handleDismiss
  }, /*#__PURE__*/React.createElement(Icon, {
    src: CloseIcon,
    attrs: {
      width: 14
    }
  })) : null;
  var actions = onAction ? /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/React.createElement("button", {
    className: classes.actionButton,
    onClick: handleAction
  }, actionText)) : null;
  return /*#__PURE__*/React.createElement("div", {
    className: classes["".concat(type, "Toast")]
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.icon
  }, iconElement), /*#__PURE__*/React.createElement("div", {
    className: classes.message
  }, message), /*#__PURE__*/React.createElement("div", {
    className: classes.controls
  }, controls), actions);
};
Toast.propTypes = {
  actionText: string,
  dismissable: bool,
  icon: object,
  id: number,
  message: string.isRequired,
  onAction: func,
  onDismiss: func,
  handleAction: func,
  handleDismiss: func,
  type: oneOf(['info', 'warning', 'error']).isRequired
};
export default Toast;